"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Form_1 = __importDefault(require("react-bootstrap/Form"));
const react_bootstrap_1 = require("react-bootstrap");
const react_1 = __importDefault(require("react"));
function FormTextArea(props) {
    let value;
    if (!props.value) {
        value = "";
    }
    else {
        value = props.value;
    }
    return (react_1.default.createElement(react_bootstrap_1.FormGroup, null,
        react_1.default.createElement(Form_1.default.Label, { className: "label", htmlFor: props.name },
            props.label,
            " ",
            props.required && react_1.default.createElement("span", { style: { color: "red" } }, "*")),
        react_1.default.createElement(Form_1.default.Control, { as: "textarea", className: "br-10", name: props.name, value: value, placeholder: props.placeholder, disabled: props.disabled, id: props.name, onChange: props.onChange, onBlur: props.onBlur }),
        props.touched && props.error && react_1.default.createElement("div", { className: "error-message mt-2" }, props.error)));
}
exports.default = FormTextArea;
;
